import React, { useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import { Label } from 'reactstrap';

const CreatableMultiSelect = ({
  availableOptions,
  selectedOptions,
  setAvailableOptions,
  setSelectedOptions,
  labelName,
  requiredField,
  isDisabled,
  option,
}) => {
  const handleChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'remove-value' || actionMeta.action === 'pop-value') {
      // Remove the option from both arrays
      const removedOption = actionMeta.removedValue;
      setAvailableOptions(availableOptions.filter(option => option.value !== removedOption.value));
      setSelectedOptions(selectedOptions.filter(option => option.value !== removedOption.value));
    } else {
      // Add or update the option
      setSelectedOptions(newValue);
    }
  };

  const handleCreate = async inputValue => {
    const newOption = { label: inputValue, value: inputValue };
    setAvailableOptions([...availableOptions, newOption]);
    setSelectedOptions([...selectedOptions, newOption]);
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter' && event.target.value.trim() !== '') {
      const newOption = {
        label: event.target.value.trim(),
        value: event.target.value.trim(),
      };
      setAvailableOptions([...availableOptions, newOption]);
      setSelectedOptions([...selectedOptions, newOption]);
      event.target.value = ''; // Clear the input after adding the option
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between">
        <Label htmlFor="choices-multiple-default" className="form-label">
          {labelName}
          {requiredField && <span className="lbl_mandatory">*</span>}
        </Label>
      </div>
      <CreatableSelect
        isMulti
        value={selectedOptions}
        onChange={handleChange}
        onCreateOption={handleCreate}
        onKeyDown={handleKeyDown}
        placeholder="Select or create options..."
        isDisabled={isDisabled}
        options={option}
      />
    </>
  );
};

export default CreatableMultiSelect;
